import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUnknown = function SvgUnknown(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "m60 0 52 30v60l-52 30L8 90V30z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "M60 56.812 11.272 29 9 32.892 60 62l51-29.108L108.729 29z",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "M63 60v58h-6V60z",
        clipRule: "evenodd"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "m60 0 52 30v60l-52 30L8 90V30zM12.532 32.616v54.768L60 114.77l47.468-27.385V32.616L60 5.23z",
        clipRule: "evenodd"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M63.975 81.264a7.64 7.64 0 0 0-4.879-1.76 7.5 7.5 0 0 0-4.84 1.76 7.7 7.7 0 0 0-2.744 5.92 7.54 7.54 0 0 0 7.584 7.584c4.224 0 7.68-3.36 7.68-7.584a7.67 7.67 0 0 0-2.801-5.92m-10.371-8.766.116.766h10.368v-.576q0-.184.005-.367c.11-3.755 1.924-6.62 5.179-8.945l3.936-2.784c5.664-4.032 9.504-9.408 9.504-16.992 0-9.696-7.776-19.104-22.656-19.104-14.208 0-21.984 9.984-21.984 20.352 0 1.44.096 2.976.48 4.32l12.096.48c-.288-.864-.384-1.92-.384-3.072 0-1.46.22-2.928.676-4.29 1.224-3.655 4.152-6.558 9.116-6.558 6.432 0 9.6 4.224 9.6 8.64 0 2.88-1.248 5.472-4.128 7.584l-4.608 3.456a24 24 0 0 0-2.885 2.54c-2.209 2.298-3.549 4.746-4.205 7.316q-.059.23-.11.462a16.5 16.5 0 0 0-.384 3.602c0 1.146.122 2.17.268 3.17m-5.216-14.933c-2.054 3.617-3.052 7.573-3.052 11.763 0 2.059.272 3.821.458 5.026l.019.127.56 3.644a15.74 15.74 0 0 0-2.861 9.06 15.54 15.54 0 0 0 15.584 15.583c8.51 0 15.68-6.811 15.68-15.584 0-3.244-.992-6.263-2.688-8.767v-5.729c0-.664.135-1.013.281-1.269.175-.307.578-.834 1.54-1.524l3.929-2.779.01-.007C84.98 62.032 90.712 54.47 90.712 43.6c0-14.597-11.857-27.104-30.656-27.104-18.77 0-29.984 13.711-29.984 28.352 0 1.676.096 4.096.788 6.518l1.59 5.566zm9.93-10.205 2.444-1.834.035-.025c.615-.451.776-.742.802-.79l.001-.003c.017-.032.056-.105.056-.34a.9.9 0 0 0-.047-.3.2.2 0 0 0-.019-.04l-.007-.006-.026-.019a1 1 0 0 0-.175-.085c-.185-.072-.598-.19-1.326-.19-.61 0-.871.116-.93.144a.6.6 0 0 0-.221.194c-.252.321-.641 1.169-.641 2.51 0 .358.015.584.03.71z",
        clipRule: "evenodd"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        d: "M64.088 73.264H53.72c-.192-1.248-.384-2.496-.384-3.936 0-5.088 2.112-9.792 7.584-13.92l4.608-3.456c2.88-2.112 4.128-4.704 4.128-7.584 0-4.416-3.168-8.64-9.6-8.64-6.816 0-9.792 5.472-9.792 10.848 0 1.152.096 2.208.384 3.072l-12.096-.48c-.384-1.344-.48-2.88-.48-4.32 0-10.368 7.776-20.352 21.984-20.352 14.88 0 22.656 9.408 22.656 19.104 0 7.584-3.84 12.96-9.504 16.992l-3.936 2.784c-3.36 2.4-5.184 5.376-5.184 9.312zm-12.576 13.92c0-4.224 3.36-7.68 7.584-7.68s7.68 3.456 7.68 7.68-3.456 7.584-7.68 7.584a7.54 7.54 0 0 1-7.584-7.584"
    })));
};

export { SvgUnknown as ReactComponent };
//# sourceMappingURL=Unknown.svg.es.js.map
